<template>
    <div class="min-w-[580px] -mt-3">
        <div v-if="finishedAction"
            class="w-full"
        >
            <div v-if="responseStatus === 200"
                class="w-full"
            >
                <div
                    class="flex flex-col justify-center items-center p-3"
                >
                    <!-- <div v-if="bulkAction.endpoint=='bulk_reject_requests'">
                        <div class="flex items-center" >
                        {{ response.data.message }}
                        </div>

                    </div> -->
                    <div>
                        This action has been performed on {{ selectedResultCount }} CRM Details.
                    </div>
                </div>
                <div class="flex justify-center items-center py-1.5  rounded-b-md">
                    <button
                        class="p-0.5 bg-dark-primary border border-dark-primary text-white rounded-md mx-1"
                        @click="closeBulkOperationClearSelected"
                    >
                        Close
                    </button>
                </div>
            </div>
            <div v-else>
                <p>{{ title }}: Failed - Bad Request.</p>
                <br>
                <p>An error occurred that prevented the completion of this action.</p>
            </div>
        </div>
        <div v-else>
            <div v-if="isLoading" role="status" class="flex justify-center items-center w-full h-[100px]">
                <svg aria-hidden="true" class="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600"
                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="white"/>
                    <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="#2E9CCA"/>
                </svg>
                <span class="sr-only">Loading...</span>
            </div>
            <div class="px-3" v-else>
                <!-- <div>
                    Are you sure you would like to perform this operation on {{ numSelectedResults}} service records?
                </div> -->
                <div class="flex items-center px-3 pt-6">
                    {{ bulkAction.message }}
                </div>
                <div v-if="bulkAction.endpoint=='bulk_update_crm_detail_notes'"
                    class="flex w-full px-3 pb-4 pt-3"
                > 
                    <textarea class="block p-2 w-full border border-gray-400 rounded-md" placeholder="Next Step Detail" v-model="detailNotes">
                    </textarea>
                </div>
                <div v-if="bulkAction.endpoint=='bulk_update_crm_detail_user'"
                    class="flex flex-col px-3 pb-4 pt-3"
                > 
                    <div class="flex flex-col space-y-2 items-start">
                        <select class="p-1 border mt-1 w-full border-gray-400 rounded-md text-gray-900 focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="" id="" v-model="detailUser">
                            <option :value="null">----------</option>
                            <option v-for="user in userOptions" :key="user.id" :value="user.id">{{ user.first_name }} {{ user.last_name }}</option>
                        </select>
                    </div>
                </div>
                <div class="grid grid-cols-8 items-center pb-1.5 border-gray-300  rounded-b-md">
                    <div class="col-span-3"></div>
                    <button
                        @click="performBulkOperation(bulkAction.endpoint)"
                        class="p-0.5 bg-accent-primary border border-accent-primary text-white rounded-md mx-1"
                    >
                        Continue
                    </button>
                    <button
                        @click="cancelBulkOperation"
                        class="p-0.5 bg-dark-primary border border-dark-primary text-white rounded-md mx-1"
                    >
                        Cancel
                    </button>
                    <div class="col-span-3"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed, reactive } from 'vue';
import { useStore } from 'vuex';
import { performBulkAction } from '@/services/CrmAction.js';
import { useToast } from 'vue-toast-notification';


const store = useStore()
const $toast = useToast()
const props = defineProps([
    'bulkAction',
    'selectedResults',
    'userOptions'
])

const emit = defineEmits([
    'set-bulk-operation-options',
    'cancel-bulk-operation',
    'close-bulk-operation',
    'refetch-results',
    'clear-selected-results',
])

const isLoading = ref(false);
const finishedAction = ref(false);
const response = ref(null);
const responseStatus = ref(null);
// const rejectionReason = ref(null)
// const redirectCampaign = ref(null)
// const copyDetails = ref(false)
const detailUser = ref(null)
const detailNotes = ref(null)
const bulkAction=reactive(props.bulkAction)
const selectedResultCount = ref(props.selectedResults.length)


const title = computed(() => {
    if(props.bulkAction) {
        if(props.bulkAction.label) {
            return props.bulkAction.label
        }
    }
    return ''
});

const numSelectedResults = computed(() => {
    if(props.selectedResults){
        if(props.selectedResults.length > 0) {
            return props.selectedResults.length
        }
    }
    return 0
})

// watch(clientId, () => {
//     console.log(clientId.value)
//     setBulkOperationOptions('engagement', clientId.value)
//     setBulkOperationOptions('invoice', clientId.value)
// })

function cancelBulkOperation() {
    console.log('cancelBulkOperation')
    emit('close-bulk-operation')
    emit('cancel-bulk-operation')
}

function closeBulkOperationClearSelected() {
    console.log('closeBulkOperationClearSelected')
    emit('close-bulk-operation')
    emit('cancel-bulk-operation')
    emit('clear-selected-results')
}

function setBulkOperationOptions(optionName, queryParams) {
    emit('set-bulk-operation-options', optionName, queryParams)
}

async function performBulkOperation() {
    // need to create and test this function, also manage response for gen invoice template.
    console.log('performBulkOperation')
    isLoading.value = true
    const token = store.state.auth.token
    const data = {
        'request_ids': props.selectedResults,
        'detail_notes': detailNotes.value,
        'user_id': detailUser.value
    }
    console.log('data')
    console.log(data)
    response.value = await performBulkAction(bulkAction.endpoint, data, token)
    console.log('bulk action response')
    console.log(response.value)
    console.log(response.value.data)
    isLoading.value = false;
    finishedAction.value = true;
    responseStatus.value = response.value.status
    if(responseStatus.value == 200) {
        
        emit('refetch-results')
    }
}

</script>